import { SearchType } from 'search/SearchContext';
import SearchPageFactory from 'search/pages/SearchPageFactory';

const { SearchPageWithApollo } = SearchPageFactory({
    type: SearchType.ForSale
});

export default SearchPageWithApollo;
